import React from "react";
import { config } from "../../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import { useEffect } from "react";
import { useRef } from "react";

const UpdateCommunity = ({ formData, setFormData, handleChange, handleSubmit, loading, onCancel, error }) => {

  const handleQuillChange = (value) => {
    setFormData(prev => ({ ...prev, benefits: value }));
  };



  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Community</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., our-community"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Our Awesome Community"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Subtitle</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Join our growing community"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Facebook Group Link</label>
          <input
            type="url"
            name="facebook_group_link"
            value={formData.facebook_group_link}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., https://facebook.com/groups/our-community"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Icon</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., fas fa-users or image URL"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Benefits:</label>
          <div className="h-64 mb-8">
            <ReactQuill
              value={formData.benefits || ''}
              onChange={handleQuillChange}
              className="bg-white rounded h-48"
              placeholder="List the benefits of joining the community"
            />
          </div>
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Button Text</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Join Now"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Button Icon</label>
          <input
            type="text"
            name="button_icon"
            value={formData.button_icon}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., fas fa-sign-in-alt"
          />
        </div>

        <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Community"}
            </button>
        </div>

      
      </form>
    </div>
  );
};

export default UpdateCommunity;